module.exports = __webpack_public_path__ + "img/556-42dfb3.png";